import React, { useContext, useEffect, useState } from 'react';
import { FaHeart } from 'react-icons/fa';
import AuthContext from '../shared/AuthContext';

const Rating = ({
  questionItemData,
  handleReadStatus,
  currentReadStatus,
  setStatusMessage,
}) => {
  const { apiClient } = useContext(AuthContext);
  const [initialCount, setInitialCount] = useState(
    () => questionItemData?.rating ?? 0
  );
  const [currentQuestion, setCurrentQuestion] = useState(questionItemData.id);
  const [updatedReadStatus, setUpdatedReadStatus] = useState(currentReadStatus);
  const [loading, setLoading] = useState(false);
  const [isRated, setIsRated] = useState(false);

  const applyRatingPayload = (data) => {
    if (!data || typeof data !== 'object') return;
    if (data.curr_count !== undefined && data.curr_count !== null) {
      setInitialCount(data.curr_count);
    }
    if (typeof data.l_Status === 'boolean') {
      setIsRated(data.l_Status);
    }
    if (typeof data.r_Status === 'boolean') {
      handleReadStatus(data.r_Status);
      setUpdatedReadStatus(data.r_Status);
    }
  };

  const fetchRating = async (questionId = currentQuestion) => {
    if (questionId == null) return;
    try {
      const response = await apiClient.get(`/api/get-r-cnt/${questionId}`);
      if (response.status === 200) {
        applyRatingPayload(response.data);
      }
    } catch (err) {
      console.error(err);
      setStatusMessage('Error Fetching Rating Count');
    }
  };

  useEffect(() => {
    setUpdatedReadStatus(currentReadStatus);
  }, [currentReadStatus]);

  useEffect(() => {
    const id = questionItemData.id;
    setCurrentQuestion(id);
    setInitialCount(questionItemData?.rating ?? 0);
    fetchRating(id);
  }, [questionItemData.id, questionItemData.rating]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchRating(currentQuestion);
    }, 10000);
    return () => clearInterval(intervalId);
  }, [currentQuestion]);

  const handleLikeClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (loading) return;
    setLoading(true);
    try {
      const payload = {
        r_Status: true,
        l_Status: isRated,
        isReadOnly: false,
      };

      const response = await apiClient.patch(
        `/api/update-r-cnt/${currentQuestion}`,
        payload
      );

      if (response.status === 200 && response.data && typeof response.data === 'object') {
        applyRatingPayload(response.data);
        setStatusMessage('Thank you for Rating this.');
      } else {
        setStatusMessage('Error Rating Answer');
      }
    } catch (err) {
      console.error(err);
      setStatusMessage('Error Rating Answer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="extra-info-rating">
      <span
        className="extra-info-rating-inner"
        role="button"
        tabIndex={0}
        rated={isRated ? 'true' : 'false'}
        quesId={currentQuestion}
        onClick={handleLikeClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleLikeClick(e);
          }
        }}
      >
        <FaHeart
          size={15}
          color={isRated ? '#f58080' : '#9ca3af'}
          style={{ marginRight: '6px', flexShrink: 0, opacity: loading ? 0.6 : 1 }}
          aria-hidden
        />
        <span className="extra-info-rating-count" aria-live="polite">
          {initialCount ?? 0}
        </span>
      </span>
    </div>
  );
};

export default Rating;
